/**
 * @preserve
 * Copyright 2015-2016 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
import { rgb2xyz } from "./rgb2xyz"
import { rgb2hsl } from "./rgb2hsl"
import { rgb2lab } from "./rgb2lab"
import { lab2xyz } from "./lab2xyz"
import { lab2rgb } from "./lab2rgb"
import { xyz2lab } from "./xyz2lab"
import { xyz2rgb } from "./xyz2rgb"

export {
    rgb2xyz,
    rgb2hsl,
    rgb2lab,
    lab2xyz,
    lab2rgb,
    xyz2lab,
    xyz2rgb,
}



/** WEBPACK FOOTER **
 ** ./src/conversion/index.ts
 **/